import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const ValueLabel = ({ value, barHeight, color }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }} // delay so it appears after bar grows
    className={`absolute bg-${color}-50 border border-${color} text-${color} px-2 rounded text-xs font-medium mb-2`}
    style={{
      bottom: `${barHeight}%`,
    }}
  >
    {value}
  </motion.div>
);

export default ValueLabel;
